// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-93e32c1c9f/0/cache/css-loader-npm-7.1.2-7540f12884-ddde22fb10.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-93e32c1c9f/0/cache/css-loader-npm-7.1.2-7540f12884-ddde22fb10.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tSy526iJrM7WXEjDeEmi{width:100%;display:block}`, "",{"version":3,"sources":["webpack://./src/embedded-policy/components/Iframe/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,aAAA","sourcesContent":[".root {\n  width: 100%;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `tSy526iJrM7WXEjDeEmi`
};
export default ___CSS_LOADER_EXPORT___;
